export default __webpack_public_path__ + "static/media/font.06fae67c.woff";